// Renders an Orello leaderboard share card to a 1080x1080 canvas and triggers PNG download.

const SIZE = 1080;
const BG = "#0F0F1A";
const ORANGE = "#F97316";
const WHITE = "#FFFFFF";
const MUTED = "rgba(255,255,255,0.55)";

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y); ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r); ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h); ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r); ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

export async function downloadShareCard({ rank, displayName, city, dealsThisMonth, monthLabel }) {
  const canvas = document.createElement("canvas");
  canvas.width = SIZE;
  canvas.height = SIZE;
  const ctx = canvas.getContext("2d");

  // Solid background
  ctx.fillStyle = BG;
  ctx.fillRect(0, 0, SIZE, SIZE);

  // Indigo + orange ambient glows
  const g1 = ctx.createRadialGradient(SIZE * 0.2, SIZE * 0.1, 0, SIZE * 0.2, SIZE * 0.1, SIZE * 0.7);
  g1.addColorStop(0, "rgba(99,102,241,0.35)"); g1.addColorStop(1, "rgba(99,102,241,0)");
  ctx.fillStyle = g1; ctx.fillRect(0, 0, SIZE, SIZE);
  const g2 = ctx.createRadialGradient(SIZE * 0.85, SIZE * 0.9, 0, SIZE * 0.85, SIZE * 0.9, SIZE * 0.6);
  g2.addColorStop(0, "rgba(249,115,22,0.22)"); g2.addColorStop(1, "rgba(249,115,22,0)");
  ctx.fillStyle = g2; ctx.fillRect(0, 0, SIZE, SIZE);

  // Dotted grid
  ctx.fillStyle = "rgba(255,255,255,0.04)";
  for (let y = 40; y < SIZE; y += 36) {
    for (let x = 40; x < SIZE; x += 36) {
      ctx.beginPath(); ctx.arc(x, y, 1.5, 0, Math.PI * 2); ctx.fill();
    }
  }

  // Wordmark "orello" with orange smile under first 'o'
  ctx.fillStyle = WHITE;
  ctx.font = "700 80px 'Space Grotesk', system-ui, sans-serif";
  ctx.textAlign = "center";
  ctx.fillText("orello", SIZE / 2, 170);
  ctx.strokeStyle = ORANGE;
  ctx.lineWidth = 8;
  ctx.lineCap = "round";
  ctx.beginPath();
  const smileCx = SIZE / 2 - 130;
  ctx.arc(smileCx, 165, 20, 0.15 * Math.PI, 0.85 * Math.PI);
  ctx.stroke();

  // Month label
  ctx.fillStyle = MUTED;
  ctx.font = "600 26px 'Space Grotesk', system-ui, sans-serif";
  ctx.fillText((monthLabel || "").toUpperCase(), SIZE / 2, 260);

  // Headline
  ctx.fillStyle = WHITE;
  ctx.font = "700 80px 'Space Grotesk', system-ui, sans-serif";
  ctx.fillText("Top agent this month", SIZE / 2, 360);

  // Rank pill
  const rankText = `#${rank}`;
  ctx.font = "800 220px 'Space Grotesk', system-ui, sans-serif";
  const pillW = ctx.measureText(rankText).width + 100;
  const pillH = 260;
  const pillX = (SIZE - pillW) / 2;
  const pillY = 440;
  ctx.fillStyle = ORANGE;
  roundRect(ctx, pillX, pillY, pillW, pillH, 36);
  ctx.fill();
  ctx.fillStyle = WHITE;
  ctx.textBaseline = "middle";
  ctx.fillText(rankText, SIZE / 2, pillY + pillH / 2 + 6);
  ctx.textBaseline = "alphabetic";

  // Display name
  ctx.fillStyle = WHITE;
  ctx.font = "700 64px 'Space Grotesk', system-ui, sans-serif";
  ctx.fillText(displayName || "—", SIZE / 2, 790);

  // City + deals line (singular/plural correct)
  ctx.fillStyle = MUTED;
  ctx.font = "500 30px 'Inter', system-ui, sans-serif";
  const dealsText = dealsThisMonth === 1 ? "1 deal this month" : `${dealsThisMonth} deals this month`;
  ctx.fillText(`${city || "—"} · ${dealsText}`, SIZE / 2, 838);

  // Bottom strip
  ctx.fillStyle = "rgba(255,255,255,0.08)";
  ctx.fillRect(0, SIZE - 110, SIZE, 1);
  ctx.fillStyle = WHITE;
  ctx.font = "600 28px 'Space Grotesk', sans-serif";
  ctx.fillText("orello.in", SIZE / 2, SIZE - 60);
  ctx.fillStyle = MUTED;
  ctx.font = "400 22px 'Inter', sans-serif";
  ctx.fillText("Verified agents · No deposit fights.", SIZE / 2, SIZE - 25);

  // Trigger PNG download
  const dataUrl = canvas.toDataURL("image/png");
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = `orello-top-${rank}-${(displayName || "").replace(/\s/g, "-")}.png`;
  document.body.appendChild(a); a.click(); a.remove();
}
